<template>
  <div>
    <courses-desktop v-if="screenType === 'desktop'"></courses-desktop>
    <courses-mobile v-else></courses-mobile>
  </div>
</template>

<script>
import CoursesDesktop from "@/components/Pages/Desktop/Dashboard/Courses/CoursesDesktop";
import CoursesMobile from "@/components/Pages/Mobile/Dashboard/Courses/CoursesMobile";

export default {
  name: "CoursesMain",
  components: {CoursesMobile, CoursesDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>